import React from 'react'
import dynamic from 'next/dynamic'
import { useBreakpointValue } from '@chakra-ui/react'
import SectionsData from '../data/sections.json'

const BeforeNltSection = dynamic(() => import('../../components/Sections/BeforeNlt'))
const BeforeNltSectionMobile = dynamic(() => import('../../components/Sections/BeforeNltMobile'))

const data = SectionsData.beforeNlt

const BeforeNltSectionContainer = () => {
  const isMobile = useBreakpointValue({ base: true, lg: false })

  return isMobile ? (
    <BeforeNltSectionMobile
      image={data.image}
      imageAlt={data.imageAlt}
      title={data.title}
      items={data.items}
      actionTitle={data.actionTitle}
      footer={data.footer}
    />
  ) : (
    <BeforeNltSection
      image={data.image}
      imageAlt={data.imageAlt}
      title={data.title}
      items={data.items}
      actionTitle={data.actionTitle}
      footer={data.footer}
    />
  )
}

export default BeforeNltSectionContainer
